
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#fdf6f0] via-[#faf0e8] to-[#fdf6f0] text-gray-700 pt-16 pb-8 border-t border-[#e8d5c4]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start justify-between gap-12 mb-12">
          {/* Company Info */}
          <div className="flex-1">
            <div className="mb-6">
              <div className="bg-[#8B1A1A] inline-block px-4 py-2 rounded-lg">
                <img
                  src="https://static.readdy.ai/image/d6d1f2a32b22918380a2589cd9f5379c/a39ee29d2ace7803e87c2156b12ede8c.png"
                  alt="天健广场"
                  className="h-24 w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed mb-6 max-w-xs">
              建材家居产业带联动的跨境供给中枢，连接批发市场、跨境电商园区与多地制造协同。
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-[#8B1A1A]"></i>
                </div>
                <span className="text-sm text-gray-600">广州市白云区沙太北路283号 · 广东天健商业广场</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-[#8B1A1A]"></i>
                </div>
                <span className="text-sm text-gray-600">020-8720 2886</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#8B1A1A]"></i>
                </div>
                <span className="text-sm text-gray-600">lianghantai@tj28.com</span>
              </div>
            </div>
          </div>

          {/* QR Code */}
          <div className="flex flex-col items-center">
            <h4 className="text-base font-bold mb-5 text-[#8B1A1A] tracking-wide">扫码咨询</h4>
            <div className="bg-white border border-[#e8d5c4] p-4 rounded-xl inline-block shadow-sm">
              <div className="w-48 h-48 rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/d6d1f2a32b22918380a2589cd9f5379c/ad1a4e168d09d0ea8cfccf9335f05b34.jpeg"
                  alt="扫码咨询"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-xs text-gray-400 text-center mt-2">微信扫码咨询</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#e8d5c4] pt-8">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-400">
              © 2024 天健广场 版权所有
            </div>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-gray-400 hover:text-[#8B1A1A] transition-colors cursor-pointer">粤ICP备11070847号</a>
              <a href="#" className="text-sm text-gray-400 hover:text-[#8B1A1A] transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-gray-400 hover:text-[#8B1A1A] transition-colors cursor-pointer">使用条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
